import { badgeQueries } from "@/hooks/useBadge.ts";
import { api } from "@/lib/http.ts";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Mark the threads list as viewed — clears the "completed since last view"
 * contribution to the awareness badge — and refreshes the badge so it updates.
 */
export const useMarkThreadsListViewed = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.post("/api/a/users/me/threads-list-viewed"),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: badgeQueries.all() });
    },
  });
};
